export default __webpack_public_path__ + "static/media/united-kingdom.e7dd4d81.png";